<!-- image-viewer-dialog.component.html -->
<div class="image-viewer-dialog" [class.video-mode]="isYoutubeVideo">
  <div class="dialog-header">
    <h2 class="dialog-title">{{ imageName }}</h2>
    <button type="button" (click)="close()" class="custom-icon-button error" aria-label="Fermer">
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    </button>
  </div>
  <div class="dialog-content">
    @if (isYoutubeVideo && youtubeEmbedUrl) {
      <div class="video-wrapper">
        <iframe
          [src]="youtubeEmbedUrl"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture "
          allowfullscreen>
        </iframe>
      </div>
    } @else {
      @if (loadingState === 1) {
        <div class="image-container">
          <img
            [src]="contentLocalUrl"
            [alt]="imageName"
            (error)="onImageError()"
            class="full-image">
        </div>
      }
      @if (loadingState === 0) {
        <div class="loading">
          <mat-progress-spinner
            mode="indeterminate"
            diameter="100"
            strokeWidth="12"
            color="primary">
          </mat-progress-spinner>
        </div>
      }
      @if (loadingState === -1) {
        <div class="no-image">
          <mat-icon>image_not_supported</mat-icon>
          <p>Aucune image disponible</p>
        </div>
      }
    }
  </div>
</div>